<div class="pending-proposal__wrapper">
    <img [@clockRotate]="{value: statusState}" (@clockRotate.done)="onAnimationDone($event)" src='/assets/images/proposal-status/pending.png'>
  
    <h4 class="pending-proposal__title">
      Proposta pendente
    </h4>
  </div>
  <fd-button [content]="'Voltar para o início'" (trigger)="navigateToHome()">
  </fd-button>